module.exports = __webpack_public_path__ + "static/media/logoBranco.01cff830.png";